module.exports = __webpack_public_path__ + "img/LCD_read_write_label.fd00c408.png";